export default __webpack_public_path__ + "CNGHoverPin.png";